$('.featured_download_open').click(function() {
    if ($('.featured_download_form').css('display') === 'none') {
        $('.featured_download_form').slideDown('slow');
        jQuery(this).addClass('hidden');
        return false;
    } else {
        $('.featured_download_form').slideUp();
        return false;
    }
});
